import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "ch_tours_lang";

const getInitialLang = () => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    const params = new URLSearchParams(window.location.search);
    const q = params.get("lang");
    if (q && translations[q]) return q;
    return "en";
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(getInitialLang);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, lang);
        } catch (e) {
            // Storage unavailable (e.g., private mode) — ignore.
        }
        document.documentElement.lang = lang;
    }, [lang]);

    const t = useMemo(() => translations[lang] || translations.en, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useI18n = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
    return ctx;
};
